import React from 'react';
import Skills from './Skills';
import Projects from './Projects';

const SkillsProjects = ({ data }) => {
    return (
        <div className='text-white'>
            <h1 className='text-center font-bold text-5xl mb-4'>
                Skills & Projects
            </h1>
            <Skills data={data} />
            <Projects data={data} />
        </div>
    );
};

export default SkillsProjects;
